var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearAnswerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4",
    "data-name": 4,
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.055,
    height: 15.173,
    viewBox: "0 0 13.055 15.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M18.725,6.139H15.7V3.262A.262.262,0,0,0,15.442,3H12.564a.262.262,0,0,0-.262.262V6.139H9.543A1.426,1.426,0,0,0,8.117,7.565V9.278a.262.262,0,0,0,.262.262v3.451a5.386,5.386,0,0,1-1.248,3.445.1.1,0,0,0-.016.029.094.094,0,0,0-.018.026h0a.149.149,0,0,0,0,.037v.136a.23.23,0,0,0,0,.039h0l.016.024a.275.275,0,0,0,.018.029l1.046,1.308a.262.262,0,0,0,.2.11H18.905a.112.112,0,0,0,.031-.013l.037-.016L19,18.12a.126.126,0,0,0,.029-.024.446.446,0,0,0,.026-.037.031.031,0,0,1,.016-.024h0l.194-.387a5.917,5.917,0,0,0,.625-2.64V9.54a.262.262,0,0,0,.262-.262V7.565A1.428,1.428,0,0,0,18.725,6.139Zm.9,1.426V9.017H19.1V7.565a1.423,1.423,0,0,0-.319-.9A.905.905,0,0,1,19.627,7.565ZM15.18,6.139h-.262V3.523h.262ZM12.826,3.523H14.4V6.139h-1.57ZM8.64,7.565a.905.905,0,0,1,.9-.9h8.136a.905.905,0,0,1,.9.9V9.017H8.64ZM9.425,9.54h8.894V9.8H8.9V9.54ZM8.9,12.991V10.325h9.418V13.7a5.407,5.407,0,0,1-.568,2.407l-.118.233H7.855A5.9,5.9,0,0,0,8.9,12.991ZM8.5,17.65l-.628-.785h9.794l.628.785ZM18.8,17.417h0l-.685-.858.115-.228a5.923,5.923,0,0,0,.617-2.629V10.325h.523V15.01A5.376,5.376,0,0,1,18.8,17.417Zm.57-7.615h-.523V9.54h.523Z",
    transform: "translate(-7.096 -3)",
    fill: "#f07171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M39.045,42a.262.262,0,0,0-.288.235,5.3,5.3,0,0,1-.544,1.886l-.188.379a.262.262,0,0,0,.471.23l.186-.377a5.834,5.834,0,0,0,.6-2.067A.262.262,0,0,0,39.045,42Z",
    transform: "translate(-29.914 -31.794)",
    fill: "#f07171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M41.262,32a.262.262,0,0,0-.262.262v1.808a.262.262,0,0,0,.523,0V32.262A.262.262,0,0,0,41.262,32Z",
    transform: "translate(-32.131 -24.414)",
    fill: "#f07171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    d: "M19.045,42a.262.262,0,0,0-.288.235,5.3,5.3,0,0,1-.544,1.886l-.188.379a.262.262,0,0,0,.471.23l.186-.377a5.834,5.834,0,0,0,.6-2.067A.262.262,0,0,0,19.045,42Z",
    transform: "translate(-15.146 -31.794)",
    fill: "#f07171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3542",
    "data-name": "Path 3542",
    d: "M21.262,32a.262.262,0,0,0-.262.262v1.808a.262.262,0,0,0,.523,0V32.262A.262.262,0,0,0,21.262,32Z",
    transform: "translate(-17.363 -24.414)",
    fill: "#f07171"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M29.045,38a.262.262,0,0,0-.262.262v.5a5.376,5.376,0,0,1-.57,2.407l-.188.379a.262.262,0,0,0,.471.23l.186-.377a5.917,5.917,0,0,0,.625-2.64v-.5A.262.262,0,0,0,29.045,38Z",
    transform: "translate(-22.53 -28.844)",
    fill: "#f07171"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M31.262,32a.262.262,0,0,0-.262.262v.785a.262.262,0,0,0,.523,0v-.785A.262.262,0,0,0,31.262,32Z",
    transform: "translate(-24.747 -24.414)",
    fill: "#f07171"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAnswerIcon);
export default __webpack_public_path__ + "static/media/ClearAnswerIcon.7ed46a07455cf0d484066f77e4fb6b37.svg";
export { ForwardRef as ReactComponent };